var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSee = function SvgSee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M44 17.6C25.1 17.6 8.8 35.32 8.8 44S25.1 70.4 44 70.4c18.9 0 35.2-17.72 35.2-26.4S62.9 17.6 44 17.6Zm0 46.51C27.74 64.11 15.09 48.1 15.09 44S27.74 23.89 44 23.89c16.26 0 28.91 16.02 28.91 20.11S60.26 64.11 44 64.11Zm7.86-24.04A8.8 8.8 0 0 1 52.8 44c0 4.83-3.97 8.8-8.8 8.8a8.84 8.84 0 0 1-8.8-8.8c0-4.83 3.97-8.8 8.8-8.8v-6.29a15.09 15.09 0 1 0 13.48 8.33l-5.62 2.83Z"
  })));
};
export default SvgSee;